import { TransferFileProvider, TransferFileType, PreviewableTransferFileExtension, TransferFile } from "../models/transferFile";

const previewableTransferFile: { extension: PreviewableTransferFileExtension, type: TransferFileType }[] = [
    { extension: '.jpg', type: 'image' },
    { extension: '.jpeg', type: 'image' },
    { extension: '.png', type: 'image' },
    { extension: '.mp3', type: 'audio' },
    { extension: '.wav', type: 'audio' },
    { extension: '.m4a', type: 'audio' },
    { extension: '.mp4', type: 'video' },
    { extension: '.mov', type: 'video' },
    { extension: '.ogg', type: 'video' },
    { extension: '.webm', type: 'video' },
    { extension: '.m4v', type: 'video' }
];

export function isTransferFilePreviewable(file: TransferFile): boolean {
    return !!previewableTransferFile.find(item => item.extension === file.ext);
}

export function getTransferFileTypeFromExtension(file: TransferFile): TransferFileType {
    const media = previewableTransferFile.find(media => media.extension === file.ext);
    if (!!media) {
        return media.type;
    }
    return 'unknown';
}

export function getTransferFileProviderFromUrl(file: TransferFile): TransferFileProvider {
    if (file.type === 'audio' || file.type === 'video') {
        return 'html5';
    }
    return null;
}

export function addMetadataToFile(file: TransferFile): TransferFile {
    file.previewable = isTransferFilePreviewable(file);
    file.type = getTransferFileTypeFromExtension(file);
    file.provider = getTransferFileProviderFromUrl(file);
    return file;
}